<template>

  <div v-loading="loading" element-loading-text="拼命加载中">

    <el-form class="search-box" ref="form" :model="form" :rules="rules">
      <el-form-item prop="order_number">
        <el-input
            ref="search"
            @focus="stopKeyborad"
            @blur="stopKeyborad"
            v-model="form.sku"
            @keydown.enter.native.prevent="getAnnexUpList"
            placeholder="扫描卡片SKU"
        >
          <el-button
              @click.prevent="getAnnexUpList"
              slot="append"
              icon="el-icon-search"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="grid-content bg-purple"
         style="color: #bd2c00"
         v-if="card_data.length>0"
    >
      <h2>待入库订单</h2>
    </div>
    <!-- 卡片捡取列表 -->
    <template   v-for="item of card_data">
        <div class="show"  :label="item.id" :key="item.id" @click="checkShelf(item)">
          <div class="line">
            <el-row :gutter="10">
              <el-col :span="16">
                <el-row>
                  <el-col :span="24">
                    <div class="grid-content bg-purple"
                    >
                      <h3>采购单号</h3>
                      <p>{{ item.purchase_no }}</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="grid-content bg-purple"
                         >
                      <h3>卡片名称</h3>
                      <p>{{ card.name }}</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="grid-content bg-purple-light">
                      <h3>数量</h3>
                      <p style="color:  #bd2c00">{{ item.quantity }}</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="grid-content bg-purple-light">
                      <h3>SKU</h3>
                      <p>{{ card.sku }}</p>
                    </div>
                  </el-col>

                  <el-col :span="24" >
                    <div class="grid-content bg-purple-light" style="color: #3967FF" v-if="user_info.depot == 0">

                        <p v-if="card.shelf">货架号: {{ card.shelf.shelf_no }}</p>
                        <p v-else>货架号: 无</p>
                    </div>
                    <div class="grid-content bg-purple-light" style="color: #3967FF" v-else-if="user_info.depot == 1">

                      <p v-if="card.xm_shelf">货架号: {{ card.xm_shelf.shelf_no }}</p>
                      <p v-else>货架号: 无</p>
                    </div>
                  </el-col>

                  <el-col :span="24">
                    <div class="grid-content bg-purple-light">
                      <p v-if="item.status===0">状态: <span style="color: #9a6e3a">待入库</span></p>
                      <p v-else-if="item.status===1">状态: <span style="color: #55a532">已入库</span></p>
                      <p v-else>状态: 其它</p>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8" @click.stop>
                <img :src="card.image" alt="" width="100%" preview="1" preview-text='图片展示1 ' @click.stop >
              </el-col>
            </el-row>

          </div>
        </div>
    </template>

    <template  v-if=" (card.shelf && user_info.depot == 0) || (card.xm_shelf && user_info.depot == 1) ">
      <div class="show bottom_show" v-if="card">
        <div class="grid-content bg-purple"
             style="color: #bd2c00"
        >
          <h2>在货架卡片</h2>
        </div>
        <div class="line" @click="checkChangeShelf">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple">
                    <h3>卡片名称</h3>
                    <p>{{ card.name }}</p>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light">
                    <h3>库存</h3>
                    <p v-if="user_info.depot == 0" style="color:  #bd2c00">{{ card.num }}</p>
                    <p v-if="user_info.depot == 1" style="color:  #bd2c00">{{ card.xm_num }}</p>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light">
                    <h3>SKU</h3>
                    <p>{{ card.sku }}</p>
                  </div>
                </el-col>

                <el-col :span="24" >
                  <div class="grid-content bg-purple-light" style="color: #3967FF">
                    <p v-if="user_info.depot == 0">货架号: {{ card.shelf.shelf_no }}</p>
                    <p v-else-if="user_info.depot == 1">货架号: {{ card.xm_shelf.shelf_no }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8"  @click.stop>
              <img :src="card.image" alt="" width="100%" preview="1" preview-text='图片展示'  @click.stop>
            </el-col>
          </el-row>

        </div>
      </div>
    </template>
    <template v-else>
      <div class="show bottom_show" v-if="card  ">
        <div class="grid-content bg-purple" style="color: #bd2c00" v-if=" card_data.length <= 0 ">
          <h2>请先创建附件预采购单</h2>
        </div>
      </div>
      <div class="show bottom_show" v-else>
        <div class="grid-content bg-purple" style="color: #bd2c00" >
          <h2>暂无卡片数据</h2>
        </div>
      </div>
    </template>
    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="90%"
        top="30vh"
        :close-on-click-modal="false"
        center>
      <el-form class="search-box" ref="shelfForm" :model="shelfForm" :rules="rules">
        <el-form-item prop="shelf_number">
          <el-col :span="10">
            实际入库数量:
          </el-col>
          <el-col :span="14">
          <el-input
              style="margin-bottom: 20px;"
              v-model="shelfForm.real_quantity"
          >
          </el-input>
          </el-col>
          <el-input
              ref="shelfSearch"
              @focus="stopKeyborad"
              @blur="stopKeyborad"
              v-model="shelfForm.shelf_number"
              @keydown.enter.native.prevent="upShelf()"
              :placeholder="placeholderInfo"
          >
            <el-button
                @click.prevent="upShelf()"
                slot="append"
                icon="el-icon-search"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <!--</span>-->
    </el-dialog>
    <el-dialog
        title="修改货架号"
        :visible.sync="changeShelfDialogVisible"
        width="90%"
        top="30vh"
        :close-on-click-modal="false"
        center>
      <el-form class="search-box" ref="changeShelfForm" :model="changeShelfForm" :rules="rules">
        <el-form-item prop="change_shelf_number">
          <el-input
              ref="changeShelfSearch"
              @focus="stopKeyborad"
              @blur="stopKeyborad"
              v-model="changeShelfForm.shelf_number"
              @keydown.enter.native.prevent="changeShelf()"
              placeholder="扫描货架号"
          >
            <el-button
                @click.prevent="changeShelf()"
                slot="append"
                icon="el-icon-search"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <!--</span>-->
    </el-dialog>
  </div>

</template>

<script>

export default {
  name: "PickList",
  data() {
    return {
      centerDialogVisible:false,
      changeShelfDialogVisible:false,
      loading: false,
      form:{
        sku:''
      },
      changeShelfForm:{
        shelf_number:'',
      },
      shelfForm:{
        shelf_number:'',
        real_quantity:0,
      },
      rules:{
        order_number: [
          {
            required: true,
            message: "请扫描订单编号",
            trigger: "blur"
          }
        ],
      },
      sku:'',
      card_data:[],
      focus_item:[],//选中的待入库id
      placeholderInfo:'请扫描卡片的货架号！',
      card:'',
      user_info:JSON.parse(localStorage.getItem('user_info'))
    }
  },
  methods: {
    checkChangeShelf(){
      this.changeShelfDialogVisible = true
      //加定时器
      this.$nextTick(() => {
        this.changeShelfOnfocusEvent()
      })
    },
    changeShelf(){
      var _this = this;
      if(!_this.user_info && !_this.user_info.depot){
        const h = this.$createElement;
        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '请重新登陆并清除缓存'),
          ])
        });
      }
      let param ={
        shelf_number : this.changeShelfForm.shelf_number,
        annex_id: this.card.id,
        warehouse:_this.user_info.depot
      };
      const h = this.$createElement;
      if( this.changeShelfForm.shelf_number == this.card.shelf.shelf_no ){

        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '货架号一致，无需更改'),
          ])
        });
        return false
      }
      //更改货架号
      this.http.fetchPost(_this.api.changeAnnexShelf, param).then((res) => {
            if(res.data.code != 200){
              this.$message({
                offset: 50,
                duration: 3000,
                message: h('p', null, [
                  h('span', null, '更新失败'),
                ])
              });
              return false
            }else{
              this.$message({
                offset: 50,
                duration: 3000,
                message: h('p', null, [
                  h('span', null, '更新货架号成功 '),
                  // h('i', { style: 'color: teal' }, 'VNode')
                ])
              });

              this.changeShelfDialogVisible = false
              this.changeShelfForm.shelf_number = ''
              this.$nextTick(() => {
                this.refreshShelf()
              })
            }
      })
    },
    getAnnexUpList(){
      let _this = this;
      if(!_this.user_info && !_this.user_info.depot){
        const h = this.$createElement;
        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '请重新登陆并清除缓存'),
          ])
        });
      }
      if( _this.form.sku !== ''){
        _this.sku =  _this.form.sku;
      }
      let param = {
        sku:_this.sku,
        warehouse:_this.user_info.depot
      };
      console.log(_this.user_info)
      _this.card_data = [];
      _this.card = '';
      this.http.fetchGet(_this.api.getAnnexUpList, param).then((res) => {
        console.log(res);
        if(res.data.code != 200){
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '暂无卡片数据'),
            ])
          });
          return false
        }else{
          _this.form.sku = '';
          if( res.data.data.annex_up_list && res.data.data.annex_up_list.length > 0 ){
            //设置卡片数据
            _this.card_data = res.data.data.annex_up_list;
          }

          if( res.data.data.annex){
            //设置卡片数据
            _this.card = res.data.data.annex;
            console.log(_this.card)
          }

        }
      })
    },

    checkShelf(item){
      if(item.status === 8 ){
        const h = this.$createElement;
        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '已配货，无需多次配货'),
          ])
        });
        return false
      }
      this.centerDialogVisible = true,
      this.focus_item = item;
      this.shelfForm.real_quantity = item.quantity;
      //加定时器
      this.$nextTick(() => {
        this.shelfOnfocusEvent()
      })
    },

    upShelf( ){
      let _this = this;
      let param = {
        annex_id: _this.card.id,
        annex_pretreatment_id:_this.focus_item.id,
        shelf_no:_this.shelfForm.shelf_number,
        real_quantity: _this.shelfForm.real_quantity,
        warehouse: _this.user_info.depot
      };

      let shelf_no = null;
      if(_this.user_info.depot == 1){
        shelf_no = null;
        let xm_shelf = _this.card.xm_shelf;
        if(xm_shelf){
          shelf_no = xm_shelf.shelf_no;
        }
      }else{
        console.log(123);
        let shelf = _this.card.shelf;
        if(shelf){
          shelf_no = _this.card.shelf.shelf_no
        }
      }

      if (shelf_no) {
        if (shelf_no != _this.shelfForm.shelf_number) {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '货架号不匹配' + shelf_no ),
            ])
          });
          return false
        }
      }
      
      this.http.fetchPost(_this.api.upAnnex, param).then((res) => {
        console.log(res.data.data)
        var data = res.data;
        if (data.code === 200) {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '入库成功 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
          this.centerDialogVisible = false
          this.card_data = []
          this.focus_item = []
          this.shelfForm.shelf_number = ''
          this.$nextTick(() => {
            this.refreshShelf()
          })
        } else {
          this.$message.error(this.shelfForm.shelf_number + " " + data.data)
        }

      })
    },

    stopKeyborad(e){
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },

    changeShelfOnfocusEvent() {
      this.$refs.changeShelfSearch.focus()
    },
    //扫描货架自动获取光标
    shelfOnfocusEvent() {
      this.$refs.shelfSearch.focus()
    },

    //上架之后更新数据
    refreshShelf() {
      this.onfocusEvent()
      this.getAnnexUpList()
    },

    //自动获取光标
    onfocusEvent() {
      this.$refs.search.focus()
    },

  },
  //被 keep-alive 缓存的组件激活时调用
  activated() {
    this.onfocusEvent()
  },
}
</script>
<style scoped lang="stylus">
  .bottom_show
    position fixed
    bottom 10px

.el-checkbox
  margin-top 10px
  margin-right 0

.el-checkbox >>> .el-checkbox__input
  vertical-align: top

.is-checked .show
  background-color #a4c9f1
  color #606266

.show {
  //float: left;
  width: 96%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 99%;

    .el-col {
      margin-top 3px
      margin-bottom: 3px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


.old-count
  margin-left: 5px;
  width: 20px;
  height: 20px;
  background-color: #ea4444;
  line-height: 20px;
  text-align: center;
  color: white;
  border-radius: 10px


</style>